const emergencySl = {
  buttons: {
    gas: 'ගෑස් සිලින්ඩරය',
    medicine: 'හදිසි ඖෂධ සේවය',
  },
  common: {
    nameLabel: 'ඔබගේ නම',
    phoneLabel: 'ජංගම අංකය',
    villageLabel: 'ගම/ප්‍රදේශය',
    houseNumberLabel: 'වීථි/භවන් අංකය',
    detailsLabel: 'අමතර තොරතුරු',
    detailsPlaceholder: 'විශේෂ උපදෙස් ඇතොත් සඳහන් කරන්න',
    districtLabel: 'දිස්ත්‍රික්කය',
    upazillaLabel: 'උපසිලාව',
    cancel: 'අවලංගු කරන්න',
  },
  gas: {
    title: 'ගෑස් සිලින්ඩර නැවත පිරවුම්',
    companyLabel: 'ගෑස් සමාගම',
    cylinderSizeLabel: 'සිලින්ඩර විශාලත්වය',
    cylinderSizePlaceholder: 'විශාලත්වය තෝරන්න',
    quantityLabel: 'ප්‍රමාණය',
    companies: {
      bashundhara: 'Bashundhara Gas',
      jamuna: 'Jamuna Gas',
      omera: 'Omera Gas',
      beximco: 'Beximco Gas',
      fresh: 'Fresh Gas',
      totalgaz: 'Totalgaz',
      others: 'වෙනත්',
    },
    cylinderSizeOptions: {
      '12kg': '12 kg',
      '33kg': '33 kg',
      '45kg': '45 kg',
    },
    price: {
      header: 'මිල විස්තර',
      unitPrice: 'එකක මිල',
      subtotal: 'උප එකතුව',
      delivery: 'බෙදාහැරීමේ ගාස්තුව',
      total: 'සම්පූර්ණ එකතුව',
      note: '* ලැබිලිදී ගෙවීම ඇත',
      unitSuffix: 'පිසීස්',
    },
    orderNow: 'දැන්ම ඇණවුම් කරන්න',
  },
  medicine: {
    title: 'හදිසි ඖෂධ සේවය',
    medicineNameLabel: 'ඖෂධයේ නාමය',
    medicineNamePlaceholder: 'කුරු ඖෂධය අවශ්‍ය ද?',
    urgencyLabel: 'අත්‍යවශ්‍යතා මට්ටම',
    urgencyOptions: {
      normal: 'සාමාන්‍ය',
      urgent: 'ඉක්මන්',
      emergency: 'හදිසි',
    },
    prescriptionLabel: 'වෙද පොත (නැතිනම්)',
    prescriptionPlaceholder: 'වෙදෙරජුගේ නියෝග හෝ ඖෂධ විස්තර',
    uploadNote: 'වෙද පොත උඩුගත කිරීම විකල්පයකි. රූපයක් හෝ PDF එකක් උඩුගත කළ හැක.',
    uploadButton: 'වෙද පොත උඩුගත කරන්න (විකල්පය)',
    selectedFilePrefix: 'තෝරාගත් ගොනුව:',
    submit: 'හදිසි ඇණවුම තබන්න',
  }
};

export default emergencySl;


